import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LensSelectionStates } from '../selection-hook';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { paiLensDefaultImpactSelectionState } from './selection-state/single-impact-selection-state';

export function selectionStateToHighlightedImpact(
  selectionState: LensSelectionStates[ImpactLensType.EU_PAIS],
  boxMode: LensBoxMode,
): ImpactCategoryId | undefined {
  if (selectionState.impact === paiLensDefaultImpactSelectionState) {
    if (boxMode === LensBoxMode.MODAL) {
      return undefined;
    } else {
      return ImpactCategoryId.GHG_EMISSIONS;
    }
  }
  return selectionState.impact;
}
